/**
 * API 配置中心
 * 统一管理所有接口地址
 */

// 接口基础地址
export const BASE_URL = {
  // 登录相关接口
  AUTH:
    process.env.VUE_APP_BASE_API || 'https://api.jkzq.net.cn/member/memberapi',
  // 机构查询接口
  ORG: (
    process.env.VUE_APP_BASE_API || 'https://api.jkzq.net.cn/member/memberapi'
  ).replace('/member/memberapi', '/api'),
  // 超级管理员接口（开发环境使用代理）
  ADMIN:
    process.env.NODE_ENV === 'production'
      ? (
          process.env.VUE_APP_BASE_API ||
          'https://api.jkzq.net.cn/member/memberapi'
        ).replace('/member/memberapi', '/sumaAdm')
      : '/sumaAdm',
  // 其他业务接口
  BUSINESS: process.env.VUE_APP_BASE_API || 'http://localhost:3000/api',
}

// 接口路径枚举
export const API_PATH = {
  // 登录
  LOGIN: '/login',
  // 注册
  REGISTER: '/register',
  // 修改密码
  CHANGE_PASSWORD: '/changePwd',
  // 获取用户信息
  GET_MEMBER_INFO: '/getMemberInfo',
  // 退出登录
  LOGOUT: '/logout',
  // 获取地区数据
  GET_AREA_DATA: '/Apiparam/getAreaData',
  // 机构列表
  ORG_LIST: '/Apiparam/listDataMap',
  // 发送短信验证码
  SEND_SMS: '/sms/send',
  // 获取岗位类型
  GET_POS_TYPE: '/Apiparam/getPosType',
  // 获取首页统计数据
  GET_INDEX_DATA: '/Apiparam/indexData',
  // 超级管理员登录
  SUPER_ADMIN_LOGIN: '/index/loginPost',
  // 超级管理员退出登录
  SUPER_ADMIN_LOGOUT: '/index/logoutPost',
  // 获取用户列表
  GET_USER_LIST: '/main/getUserList',
  // 冻结/解冻用户
  FREEZE_USER: '/main/freezeUser',
  // 删除用户
  DELETE_USER: '/main/deleteUser',
  // 创建管理员
  CREATE_ADMIN: '/main/createAdmin',
  // 重置密码
  RESET_PASSWORD: '/main/resetPassword',
  // 获取填报时间列表
  GET_FILL_TIME_LIST: '/main/getFillTimeList',
  // 添加填报时间
  ADD_FILL_TIME: '/main/addFillTime',
  // 编辑个人信息（从业人员）
  UPDATE_PROFILE: '/profile',
  // 获取数据填报时间列表（从业人员端）
  GET_FILL_TIME_DATA: '/timeDataList',
  // 获取招聘岗位列表
  GET_JOB_LIST: '/Apiparam/getJobList',
  // 获取招聘岗位详情
  GET_JOB_DETAIL: '/Apiparam/getJobDetail',
  // 获取国家标准列表
  GET_NATION_LIST: '/getNationList',
  // 获取地方标准/团体标准列表
  GET_ALL_STANDARD_LIST: '/allStandardList',
  // 查看国家标准详情
  VIEW_NATION_INFO: '/viewNationInfo',
  // 查看地方标准/团体标准详情
  VIEW_STANDARD: '/viewStandard',
  // 下载地方标准/团体标准
  DOWNLOAD_STANDARD: '/downloadStandard',
  // 获取我的标准列表
  GET_MY_STANDARD: '/myStandard',
  // 上传标准
  ADD_STAND_DATA: '/addStandData',
  // 上传文件
  UPLOAD_FILE: '/Apiparam/updatefile',
  // 删除我的标准
  DELETE_STANDARD: '/deleteStandard',
  // 提交/编辑标准
  SUBMIT_STANDARD: '/submitStandard',
  // 获取政策法规分类列表
  GET_CATE_LIST: '/getCateList',
  // 获取国家政策列表
  GET_NAT_POL_LIST: '/getNatPolList',
  // 获取地方政策列表
  GET_LOCAL_POL_LIST: '/getLocalPolList',
  // 查看政策详情
  VIEW_POLICY_INFO: '/viewPolicyInfo',
  // 管理员端整体概览
  DATA_OVERVIEW: '/dataOverview',
  // 管理员端机构概览
  ORG_OVERVIEW: '/orgOverview',
  // 管理员端岗位需求趋势
  JOB_TREND: '/jobTrend',
  // 管理员端Top 5热门岗位
  TOP_JOBS: '/topJobs',
  // 管理员端岗位学历和证书要求
  JOB_REQUIREMENTS: '/jobRequirements',
  // 管理员端从业人员概览
  PRACTITIONER_OVERVIEW: '/practitionerOverview',
  // 管理员端从业人员能力评估
  PRACTITIONER_CAPABILITY: '/practitionerCapability',
  // 获取填报列表（从业人员端）
  GET_SURVEY_LIST: '/survey/getList',
  // 获取机构数据列表（管理员端）
  GET_SURVEY_DATA_LIST: '/survetDataList',
  // 初始化填报（从业人员端）
  INIT_SURVEY: '/survey/init',
  // 获取填报进度（从业人员端）
  GET_PROGRESS: '/survey/getProgress',
  // 查看填报详情（从业人员端）
  VIEW_SURVEY: '/survey/view',
  // 保存步骤/提交（从业人员端）
  SAVE_STEP: '/survey/saveStep',
}

// 请求超时时间
export const TIMEOUT = 10000

// 成功状态码
export const SUCCESS_CODES = [200, 1]
